<template>
    <div class="relative animate-pulse">
        <PhChatCircle class="size-20" />
        <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 200 200"
            class="w-full h-full absolute inset-0"
        >
            <circle
                v-for="(dot, index) in dots"
                :key="index"
                class="fill-current"
                stroke="none"
                r="13"
                :cx="65 + index * 35"
                cy="100"
            >
                <animate
                    attributeName="opacity"
                    calcMode="spline"
                    dur="2"
                    values="1;0.2;1"
                    keySplines=".5 0 .5 1;.5 0 .5 1"
                    repeatCount="indefinite"
                    :begin="`${index * 0.2}s`"
                />
            </circle>
        </svg>
    </div>
</template>

<script>
import { PhChatCircle } from '@phosphor-icons/vue'

export default {
    name: 'CommentLoadIcon',

    components: {
        PhChatCircle,
    },

    created() {
        this.dots = [0, 1, 2]
    },
}
</script>
